import type { PortalHelpRole, PortalHelpConfig } from './portalHelpTypes';
import { APPRENANT_HELP } from './portalHelpApprenant';
import { FORMATEUR_HELP } from './portalHelpFormateur';
import { PARTENAIRE_HELP } from './portalHelpPartenaire';
import { ADMIN_HELP } from './portalHelpAdmin';

export type {
  PortalHelpRole,
  HelpSection,
  HelpFaq,
  PortalHelpConfig,
} from './portalHelpTypes';

export { PORTAL_HELP_PATHS, PORTAL_PROFILE_PATHS, resolvePortalHelpPath, resolvePortalProfilePath } from './portalHelpTypes';

export { APPRENANT_HELP } from './portalHelpApprenant';
export { FORMATEUR_HELP } from './portalHelpFormateur';
export { PARTENAIRE_HELP } from './portalHelpPartenaire';
export { ADMIN_HELP } from './portalHelpAdmin';

export const PORTAL_HELP: Record<PortalHelpRole, PortalHelpConfig> = {
  apprenant: APPRENANT_HELP,
  formateur: FORMATEUR_HELP,
  partenaire: PARTENAIRE_HELP,
  admin: ADMIN_HELP,
};

export function getPortalHelpConfig(portal: PortalHelpRole): PortalHelpConfig {
  return PORTAL_HELP[portal];
}
